"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE_OPTIONS = exports.USE_INDICATOR_COLORS = exports.USE_COLORS = exports.USE_CLASSES = exports.ICON_SIZE_MAP = exports.ICON_COLOR_MAP = void 0;

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _Color = require("../core/Color");

var ICON_COLOR_MAP = {
  danger: colors.ALERT_DANGER,
  primary: colors.LORAX,
  secondary: colors.LORAX,
  'secondary-ghost': colors.OLAF,
  tertiary: colors.HEFFALUMP,
  success: colors.OZ,
  link: colors.CALYPSO,
  'on-dark': colors.OLAF
};
exports.ICON_COLOR_MAP = ICON_COLOR_MAP;
var ICON_SIZE_MAP = {
  'extra-small': 10,
  small: 16,
  medium: 24
};
exports.ICON_SIZE_MAP = ICON_SIZE_MAP;
var USE_CLASSES = {
  danger: 'private-spinner--destructive',
  primary: 'private-spinner--primary',
  'primary-white': 'private-spinner--primary-white',
  secondary: 'private-spinner--secondary',
  'secondary-ghost': 'private-spinner--secondary-ghost',
  tertiary: 'private-spinner--tertiary',
  success: 'private-spinner--success',
  'tertiary-light': 'private-spinner--tertiary',
  // same as tertiary
  link: 'private-spinner--link',
  'on-dark': 'private-spinner--on-dark'
};
exports.USE_CLASSES = USE_CLASSES;
var USE_COLORS = {
  danger: colors.CANDY_APPLE_MEDIUM,
  primary: colors.LORAX_MEDIUM,
  'primary-white': colors.FLINT,
  secondary: colors.LORAX_MEDIUM,
  tertiary: colors.FLINT,
  'tertiary-light': colors.FLINT,
  success: colors.OZ_MEDIUM,
  link: colors.CALYPSO_MEDIUM,
  ghost: 'transparent',
  'on-dark': (0, _Color.rgba)(colors.OLAF, 0.5)
};
exports.USE_COLORS = USE_COLORS;
var USE_INDICATOR_COLORS = {
  danger: colors.ALERT_DANGER,
  primary: colors.LORAX,
  'primary-white': colors.HEFFALUMP,
  secondary: colors.LORAX,
  'secondary-ghost': colors.OLAF,
  tertiary: colors.HEFFALUMP,
  'tertiary-light': colors.HEFFALUMP,
  success: colors.OZ,
  link: colors.CALYPSO,
  ghost: colors.OLAF,
  'on-dark': colors.OLAF
};
exports.USE_INDICATOR_COLORS = USE_INDICATOR_COLORS;
var SIZE_OPTIONS = {
  'extra-small': '20px',
  small: '28px',
  medium: '40px'
};
exports.SIZE_OPTIONS = SIZE_OPTIONS;